import React from "react";

// Shows where the bank analytics came from, using the `source` sent by the backend
const PROVIDERS = {
  onemoney: { label: "OneMoney", color: "#1E40AF", background: "#EAF0FF", border: "#C7D5FB" },
  finbox: { label: "Finbox", color: "#92400E", background: "#FFF4E5", border: "#F5D3A6" },
};
export function SourceChip({ source }) {
  const provider = PROVIDERS[source];
  if (!provider) return null;
  const { label, color, background, border } = provider;
  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 8px",
        marginLeft: "8px",
        borderRadius: "999px",
        backgroundColor: background,
        border: `1px solid ${border}`,
        color,
        fontSize: "11px",
        lineHeight: "16px",
        fontWeight: 600,
        fontFamily: "Outfit",
        verticalAlign: "middle",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
}
